import { Component, OnInit } from '@angular/core';
import { switchMap } from 'rxjs';
import { ThirdPartyManager } from '../../../../managers/third-party.manager';

@Component({
    selector: 'lex-third-party-clio',
    templateUrl: './third-party-clio.component.html',
    styleUrls: ['./third-party-clio.component.scss'],
    standalone: false
})
export class ThirdPartyAppClioComponent implements OnInit {

	public isLinked: boolean = false;
	public isLoading: boolean = true;

	constructor(private thirdPartyManager: ThirdPartyManager) { }

	ngOnInit(): void {
		this.isLoading = true;
		this.thirdPartyManager.isClioLinked().subscribe((data) => {
			this.isLinked = data;
		}, null, () => {
			this.isLoading = false;
		});
	}

	public learnMore(): void {
		window.open('https://www.clio.com/', '_blank');
	}

	public unlink(): void {
		this.thirdPartyManager.unlinkClio()
			.pipe(switchMap(() => {
				this.isLoading = true;
				return this.thirdPartyManager.isClioLinked();
			}))
			.subscribe((data) => {
				this.isLinked = data;				
			}, null, () => {
				this.isLoading = false;
			});
	}
}
